import { useId } from 'react';
import ActionButton from '@/components/Button/ActionButton';
import { HStack, VStack } from '@/components/Layout';
import { Text } from '@/components/Typography/Text';
import type { JobFunctionValue } from '@/features/section-attribute/types';
import { useCommonTranslation } from '@/hooks/useCommonTranslation';
import { CFormItemBase, type CFormItemProps, buildCFormItem } from '../CFormItem';
import { MasterDataCombobox } from './MasterDataCombobox';
type Props = CFormItemProps & {
  value?: JobFunctionValue[];
  onChange: (value: JobFunctionValue[]) => void;
};
export const CFormJobFunctionListItem = buildCFormItem((props: Props) => {
  const tc = useCommonTranslation();
  const idPrefix = useId();
  const values = props.value ?? [];
  const handleChange = (index: number, id: string, name?: string) => {
    const next = values.map(v => ({
      ...v
    }));
    next[index] = {
      jobFunctionId: id,
      name: name || ''
    };
    props.onChange(next);
  };
  const handleAdd = () => {
    props.onChange([...values, {
      jobFunctionId: '',
      name: ''
    }]);
  };
  const handleRemove = (index: number) => {
    props.onChange(values.filter((_, i) => i !== index));
  };
  const renderReadMode = () => {
    if (values.length === 0) return <Text variant="p">-</Text>;
    return <VStack className="gap-2 w-full">
        {values.map((v, index) => <Text key={`${idPrefix}-${index}`} variant="labelLarge">
            {v.name || '-'}
          </Text>)}
      </VStack>;
  };
  const renderWriteMode = () => {
    return <VStack className="gap-3">
        {values.map((v, index) => <HStack key={`${idPrefix}-${index}`} className="gap-2 items-center">
            <div className="flex-1 min-w-0">
              <MasterDataCombobox value={v.jobFunctionId ?? undefined} displayValue={v.name ?? undefined} onChange={(id, name) => handleChange(index, id || '', name)} apiPath="/v2/job-functions" queryKeyPrefix="jobFunctions" disabled={props.readonly} />
            </div>
            {!props.readonly && <ActionButton icon="Trash2Icon" variant="ghost" iconColor="muted" onClick={() => handleRemove(index)} aria-label={tc('action.delete')} />}
          </HStack>)}
        {!props.readonly && <ActionButton icon="PlusIcon" variant="ghost" size="sm" className="self-start" onClick={handleAdd}>
            {tc('action.add')}
          </ActionButton>}
      </VStack>;
  };
  return <CFormItemBase {...props} readComponent={renderReadMode()} writeComponent={renderWriteMode()} />;
});